import { useContext } from 'react';
import { FeatureContext } from 'contexts/FeatureContext';

const useFeatures = () => useContext(FeatureContext);

export default useFeatures;
